import inView from './includes/inview';

// JavaScript to be fired on all pages
export default {
    init() {
        // Offcanvas functions
        this.offcanvas()

        // Inview waypoints (animating items when they are scrolled to)
        inView.init()

        // Overflow slider
        if ($('.slider-overflow').length) {
            this.sliderOverflow()
        }

    },
    offcanvas() {

        // Toggle offcanvas
        $('.offcanvas-toggle').click( (e) => {
            e.preventDefault()
            $('.offcanvas').fadeToggle()
        })

        // Desktop column hover
        $('.nav--offcanvas > li').hover( function() {
            $(this).find('.sub-menu').slideDown()
        }, function() {
            $(this).find('.sub-menu').slideUp()
        })

        // Mobile row click
        $('.nav--offcanvas-mobile > li.menu-item-has-children > div > a').click( function(e) {
            e.preventDefault()
            $(this).toggleClass('sub-menu-open')
            $(this).parent().find('.sub-menu').slideToggle()
        })

    },
    sliderOverflow() {

        $('.slider-overflow').each( function() {

            const sliderNav = $(this).next('.slider-overflow-nav')

            $(this).slick({
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                rows: 0,
                appendArrows: sliderNav,
                prevArrow:'<button type="button" class="slick-arrow slick-arrow--prev"><span><i class="far fa-long-arrow-alt-left"></i></span></button>',
                nextArrow:'<button type="button" class="slick-arrow slick-arrow--next"><span><i class="far fa-long-arrow-alt-right"></i></span></button>',
                dots: false,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })
        })

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js